import { config } from '@gen2/config';
import { TUser } from '@gen2/types/user';
import { AxiosPromise } from 'axios';
import axios from '../axios.request';

export type TWatchRequest = {
  inviteId: string;
  user_ids?: string[];
  team_ids?: string[];
};

export const watch = ({
  inviteId: id,
  user_ids,
  team_ids,
}: TWatchRequest): AxiosPromise<unknown> => {
  return axios.request({
    url: `${config.apiVersion.v1}/invites/${id}/watch`,
    data: {
      user_ids,
      team_ids,
    },
    method: 'post',
  });
};

export type TUWatchRequest = {
  inviteId: string;
  user_id?: string;
};

export const unwatch = ({
  inviteId: id,
  user_id = '',
}: TUWatchRequest): AxiosPromise<unknown> => {
  return axios.request({
    url: `${config.apiVersion.v1}/invites/${id}/unwatch`,
    data: {
      user_id,
    },
    method: 'post',
  });
};

export type TWatcher = {
  id: string;
  user: TUser;
};

export type TGetWatchersResponse = {
  data: {
    is_watching: boolean;
    watchers: TWatcher[];
  };
};

export const getWatchers = (
  inviteId: string,
): AxiosPromise<TGetWatchersResponse> => {
  return axios.request({
    url: `${config.apiVersion.v1}/invites/${inviteId}/watchers`,
    params: {
      per_page: 50, // max limit in BE
    },
    method: 'get',
  });
};
